import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { usePopover } from '../../../Popovers/redux/hooks';
import { PopoverType } from '../../../Popovers/redux/types';
import { getDeviationNotificationQueue } from '../../../DeviationPage/redux/helpers';
import AddToCollectionPopover from '../../_partials/AddToCollectionPopup';
import FavouriteButton, { Props } from './FavouriteButton';
import PositionOnlyPopperPopover from '@wix/da-ds/pkg/popper/presets/PositionOnlyPopperPopover';
import type { OffsetModifier } from '@wix/da-ds/pkg/popper/types';

const offsetModifier: OffsetModifier = [0, 20];

const FavouriteButtonWithPopover: React.FC<Props> = props => {
  const isMobile = useContext(MobileContext);
  const { actionBarType } = props;
  const { popover, removePopover, togglePopover } = usePopover(
    actionBarType === 'primary'
      ? PopoverType.ADD_TO_COLLECTION_PRIMARY
      : PopoverType.ADD_TO_COLLECTION_SECONDARY
  );
  const notificationQueue = isMobile
    ? 'default'
    : getDeviationNotificationQueue(props.deviation);

  return (
    <PositionOnlyPopperPopover
      popoverContent={
        <AddToCollectionPopover
          isPrivateCollections={false}
          collectibleDeviation={props.deviation}
          notificationQueue={notificationQueue}
          ignorePreselectedCollections={
            popover.params?.ignorePreselectedCollections
          }
          onClose={removePopover}
        />
      }
      placement="bottom"
      isVisible={popover.isOpen}
      offsetModifier={offsetModifier}
      onClickOutside={isMobile ? undefined : removePopover}
    >
      <FavouriteButton {...props} onArrowClick={togglePopover} />
    </PositionOnlyPopperPopover>
  );
};
FavouriteButtonWithPopover.displayName = 'FavouriteButtonWithPopover';

export default FavouriteButtonWithPopover;
